// import { removeClass } from '@/common/js/util.js'
const equment = {
  state: {
    floatingVisible: false,
    floatingData: {}
  },
  actions: {

  },
  mutations: {
    setFloat(state, visible) {
      state.floatingVisible = visible
    },
    setFloatingData(state, data) {
      state.floatingData = data
    }
  }
}

export default equment



// WEBPACK FOOTER //
// ./src/store/modules/home.js